import useThemeConfig from "src/themes/useThemeConfig";
import React from "react";

export default function ShowcaseDealsList(props) {
  const config = useThemeConfig();
  const ThemedShowcaseDealsList = config.components.ShowcaseDealsList;

  return <ThemedShowcaseDealsList {...props} />;
}
